import React, { createContext, useContext, useState, useEffect } from 'react';

const FavoritesContext = createContext();

export const FavoritesProvider = ({ children }) => {
    const [favorites, setFavorites] = useState([]);
    const [isFavoritesOpen, setIsFavoritesOpen] = useState(false);

    useEffect(() => {
        const savedFavorites = localStorage.getItem('sugarhut_favorites');
        if (savedFavorites) {
            setFavorites(JSON.parse(savedFavorites));
        }
    }, []);

    const toggleFavorite = (item) => {
        setFavorites(prev => {
            const isFav = prev.find(f => f.id === item.id);
            let next;
            if (isFav) {
                next = prev.filter(f => f.id !== item.id);
            } else {
                next = [...prev, item];
            }
            localStorage.setItem('sugarhut_favorites', JSON.stringify(next));
            return next;
        });
    };

    const isFavorite = (itemId) => favorites.some(f => f.id === itemId);

    return (
        <FavoritesContext.Provider value={{
            favorites,
            toggleFavorite,
            isFavorite,
            isFavoritesOpen,
            setIsFavoritesOpen
        }}>
            {children}
        </FavoritesContext.Provider>
    );
};

export const useFavorites = () => useContext(FavoritesContext);
